export const SettingsIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 10.5C9.10457 10.5 10 9.60457 10 8.5C10 7.39543 9.10457 6.5 8 6.5C6.89543 6.5 6 7.39543 6 8.5C6 9.60457 6.89543 10.5 8 10.5Z"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33301 9.08679V7.91345C1.33301 7.22012 1.89967 6.64679 2.59967 6.64679C3.80634 6.64679 4.29967 5.79345 3.69301 4.74679C3.34634 4.14679 3.55301 3.36679 4.15967 3.02012L5.31301 2.36012C5.83967 2.04679 6.51967 2.23345 6.83301 2.76012L6.90634 2.88679C7.50634 3.93345 8.49301 3.93345 9.09967 2.88679L9.17301 2.76012C9.48634 2.23345 10.1663 2.04679 10.693 2.36012L11.8463 3.02012C12.453 3.36679 12.6597 4.14679 12.313 4.74679C11.7063 5.79345 12.1997 6.64679 13.4063 6.64679C14.0997 6.64679 14.673 7.21345 14.673 7.91345V9.08679C14.673 9.78012 14.1063 10.3535 13.4063 10.3535C12.1997 10.3535 11.7063 11.2068 12.313 12.2535C12.6597 12.8601 12.453 13.6335 11.8463 13.9801L10.693 14.6401C10.1663 14.9535 9.48634 14.7668 9.17301 14.2401L9.09967 14.1135C8.49967 13.0668 7.51301 13.0668 6.90634 14.1135L6.83301 14.2401C6.51967 14.7668 5.83967 14.9535 5.31301 14.6401L4.15967 13.9801C3.55301 13.6335 3.34634 12.8535 3.69301 12.2535C4.29967 11.2068 3.80634 10.3535 2.59967 10.3535C1.89967 10.3535 1.33301 9.78012 1.33301 9.08679Z"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
